// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"e1iKv":[function(require,module,exports) {
class NSSCartATCForm extends HTMLElement {
    constructor(){
        super();
        this.debug = false;
    }
    connectedCallback() {
        if (this.debug) console.log(`[NSS] Cart ATC Form connected.`);
        this.querySelector(`[name="id"]`).style.display = `none`;
        this.initATCForm();
    }
    initATCForm() {
        // Option events
        const optionEls = this.querySelectorAll(`.nss-cart-atc-form__option`);
        optionEls.forEach((optionEl)=>{
            optionEl.addEventListener(`mouseleave`, ()=>{
                optionEl.setAttribute(`nss-option-open`, false);
            });
            const selectedEl = optionEl.querySelector(`.nss-cart-atc-form__option-selected`);
            selectedEl.addEventListener(`click`, ()=>{
                if (optionEl.getAttribute(`nss-option-open`) == `true`) optionEl.setAttribute(`nss-option-open`, false);
                else optionEl.setAttribute(`nss-option-open`, true);
            });
            const valueEls = optionEl.querySelectorAll(`[nss-value]`);
            valueEls.forEach((valueEl)=>{
                const buttonEl = valueEl.querySelector(`button`);
                buttonEl.addEventListener(`click`, ()=>{
                    selectedEl.innerHTML = buttonEl.innerHTML;
                    const string = selectedEl.querySelector(`span`).textContent;
                    if (string.length > 20) selectedEl.querySelector(`span`).textContent = `${string.substring(0, 20)}...`;
                    optionEl.setAttribute(`nss-option-open`, false);
                    optionEl.setAttribute(`nss-value`, valueEl.getAttribute(`nss-value`));
                    valueEls.forEach((valueEl)=>valueEl.setAttribute(`nss-selected`, false));
                    valueEl.setAttribute(`nss-selected`, true);
                    this.updateSelections();
                });
            });
        });
    }
    updateSelections() {
        const options = [];
        const optionEls = this.querySelectorAll(`.nss-cart-atc-form__option`);
        optionEls.forEach((optionEl)=>{
            const group = [
                optionEl.getAttribute(`nss-position`),
                optionEl
            ];
            options.push(group);
        });
        options.sort((a, b)=>a[0] - b[0]);
        let handle = ``;
        options.forEach((option)=>{
            if (handle === ``) handle = option[1].getAttribute(`nss-value`);
            else handle = `${handle}-${option[1].getAttribute(`nss-value`)}`;
        });
        const productSelectEl = this.querySelector(`[name="id"]`);
        const selectOptionEl = productSelectEl.querySelector(`[nss-option-handle="${handle}"]`);
        productSelectEl.value = selectOptionEl.value;
        const optionCompare = selectOptionEl.getAttribute(`nss-option-compare-price`);
        const optionPrice = selectOptionEl.getAttribute(`nss-option-price`);
        // Update image
        const optionImage = selectOptionEl.getAttribute(`nss-option-image`);
        this.parentElement.parentElement.querySelector(`[nss-cart-image] img`).src = optionImage;
        // Update pricing
        const formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD"
        });
        const priceCompareEl = this.querySelector(`[nss-compare]`);
        const priceEl = this.querySelector(`[nss-price]`);
        priceCompareEl.innerHTML = formatter.format(optionCompare / 100);
        priceEl.innerHTML = formatter.format(optionPrice / 100);
        const savingsEl = this.querySelector(`[nss-savings]`);
        const savings = Math.round((optionCompare - optionPrice) / optionCompare * 100).toFixed(0);
        savingsEl.innerHTML = savings;
        // Update available
        const optionAvailable = selectOptionEl.getAttribute(`nss-option-available`);
        const buttonsEl = this.querySelector(`.nss-cart__buttons`);
        buttonsEl.setAttribute(`nss-available`, optionAvailable);
    }
}
customElements.define("nss-cart-atc-form", NSSCartATCForm);

},{}]},["e1iKv"], "e1iKv", "parcelRequire83e8")

//# sourceMappingURL=nss-cart-atc-form.js.map
